export function formatFileExtensions(accept: string): string {
  return accept
    .split(",")
    .map((ext) => ext.trim().replace(/^\./, ""))
    .filter(Boolean)
    .join(", ");
}
